import { render, staticRenderFns } from "./discountStatusBadge.vue?vue&type=template&id=f726d99a&"
import script from "./discountStatusBadge.vue?vue&type=script&lang=js&"
export * from "./discountStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports